import { useTranslation } from 'react-i18next';

import { PageLayout, PageTitle } from 'core/components';
import { SelectionCountProvider } from 'core/states';
import { ProjectList } from 'projects/components';

export const ProjectListPage = () => {
  const { t } = useTranslation();

  return (
    <PageLayout title={t('titleProjects')}>
      <SelectionCountProvider>
        <PageTitle title={t('titleProjects')} />
        <ProjectList />
      </SelectionCountProvider>
    </PageLayout>
  );
};
